import * as React from "react";
import {Create, SimpleForm} from "react-admin";
import {CalendarEventFormFields, CalendarEventToolbar} from "./form";

export const CreateCalendarEvent = () => (
    <>
        <h2 className="dailyTitle">New Calendar Event</h2>
        <Create title="Calendar Events" redirect="edit">
            <SimpleForm toolbar={<CalendarEventToolbar className="customerActionToolbar" />}>
                <CalendarEventFormFields className="customer-form-wrap" />
            </SimpleForm>
        </Create>
    </>
);
